import { DEFAULT_FORM_NAME } from "./determineFormName";

type FormConfig = {
  signupPath: string;
  redirectPath?: string;
};

const FORM_CONFIGS: Record<string, FormConfig> = {
  [DEFAULT_FORM_NAME]: {
    signupPath: "/sign-up/fresh",
    redirectPath: "/sign-up/fresh/recipes",
  },
  "fresh-new-user": {
    signupPath: "/sign-up/fresh",
  },

};

/**
 * Gets the signup page path for a form name (start of flow).
 * @param formName - The form name
 * @returns The signup page path, or default signup path if not found
 */
export function getSignupPathForFormName(formName: string): string {
  return FORM_CONFIGS[formName]?.signupPath
    ?? FORM_CONFIGS[DEFAULT_FORM_NAME].signupPath;
}

/**
 * Gets the redirect destination for a form name after successful restoration.
 * If no redirect path is configured for the form, falls back to the signup path (start of flow).
 * @param formName - The form name
 * @returns The redirect path, or signup path if no redirect is configured
 */
export function getRedirectPathForFormName(formName: string): string {
  return FORM_CONFIGS[formName]?.redirectPath ?? FORM_CONFIGS[formName]?.signupPath
    ?? FORM_CONFIGS[DEFAULT_FORM_NAME].signupPath;
}

/**
 * Whether a restored cart for this form can resume past the start of the flow
 * (i.e. the form has a redirect path configured).
 * @param formName - The form name
 */
export function hasResumeRedirectForFormName(formName: string): boolean {
  return Boolean(FORM_CONFIGS[formName]?.redirectPath);
}

/** Guesses the current form name based on the current URL's path */
export function getFormNameFromPath(pathname: string): string | null {
  for (const [ formName, config ] of Object.entries(FORM_CONFIGS)) {
    if (pathname.startsWith(config.signupPath)) {
      return formName;
    }
  }
  const fallback = pathname.match(/^\/forms\/([^/]+)(\/.*)?$/)?.[1];
  return fallback ?? null;
}
